<div class="listing-details-wrapper">
  <ion-progress-bar [value]="completePercent / 100" class="divider-line" style="height: 3px"></ion-progress-bar>
  <div class="listing-icon icon-boondock">
    <div class="w-embed" style="width: 100%">
      <curbnturf-map-icons type="boondockPinLarge" [green]="true"> </curbnturf-map-icons>
    </div>
  </div>
  <img
    [src]="photoUrl"
    [alt]="boondock?.photos[0]?.caption || 'Boondock Image for ' + boondock?.name"
    loading="lazy"
    width="380"
    class="listing-info-image"
  />
  <div class="listing-info-description">
    <div class="listing-name-header">
      <h3 [innerHtml]="boondock?.name"></h3>
    </div>
    <div>
      <div class="listing-status">
        <div *ngIf="incompleteMessages.length > 0">
          <ion-button id="info-button-{{ boondock.syncId }}" fill="clear" size="small">
            <ion-icon name="information-circle"></ion-icon>
          </ion-button>
          <ion-popover
            trigger="info-button-{{ boondock.syncId }}"
            reference="event"
            dismiss-on-select="true"
            *ngIf="incompleteMessages.length > 0"
          >
            <ng-template>
              <ion-content>
                <ion-list>
                  <ion-item *ngFor="let message of incompleteMessages" lines="full">{{ message }}</ion-item>
                </ion-list>
              </ion-content>
            </ng-template>
          </ion-popover>
        </div>

        <div>
          Your boondock is {{ completePercent }}% complete<span *ngIf="isComplete">!</span>
          <span *ngIf="!isComplete"> finish it now. </span>
        </div>
      </div>
    </div>
  </div>
  <div class="listing-options-inner">
    <a *ngIf="!isComplete" (click)="resumeWizard()" class="cnt-button w-button"> Resume </a>
    <a
      *ngIf="isComplete"
      [routerLink]="['', 'listings', 'boondocking', 'edit', boondock?.id ?? boondock?.syncId]"
      class="cnt-button w-button"
    >
      Edit
    </a>
    <a [routerLink]="boondockRoute" class="cnt-button w-button"> View </a>

    <ng-container *ngIf="publishable && isOnline">
      <ng-template #publishTemplate>
        <button type="button" class="cnt-button w-button">Publish</button>
      </ng-template>
      <curbnturf-hide-confirmation-modal
        [name]="'publish ' + boondock?.name"
        [template]="publishTemplate"
        [hideFunction]="publish(boondock)"
        *ngIf="!boondock?.available"
      >
      </curbnturf-hide-confirmation-modal>
    </ng-container>

    <ng-container *ngIf="isAvailable && isOnline">
      <ng-template #hideTemplate>
        <button type="button" class="cnt-button w-button">Hide</button>
      </ng-template>
      <curbnturf-hide-confirmation-modal
        [name]="'hide ' + boondock?.name"
        [template]="hideTemplate"
        [hideFunction]="hide(boondock)"
        *ngIf="boondock?.available"
      >
      </curbnturf-hide-confirmation-modal>
    </ng-container>

    <ng-template #boondockDeleteTemplate>
      <button type="button" class="delete-button cnt-button">
        <span class="cnt-button-icon">
          <curbnturf-misc-svg icon="new-trash" class="normal"> </curbnturf-misc-svg>
          <curbnturf-misc-svg icon="new-trash" color="#fff" class="hovered"> </curbnturf-misc-svg>
        </span>
        <span class="cnt-button-copy">Delete</span>
      </button>
    </ng-template>
    <curbnturf-delete-confirmation-modal
      [name]="boondock?.name"
      [template]="boondockDeleteTemplate"
      [deleteFunction]="removeBoondockFunction(boondock?.id ?? boondock?.syncId)"
    >
    </curbnturf-delete-confirmation-modal>
  </div>
</div>
